import { createGlobalStore } from 'hox';
import { useState } from 'react';

import { MenuOption } from '../types';

function useAccount() {
  const [groupCompanyGuid, setGroupCompanyGuid] = useState<string>('');
  const [company, setCompany] = useState<MenuOption[]>([]);
  const [account, setAccount] = useState<{ name: string; role: string | null }>(
    { name: '', role: 'Administrator' }
  );
  return {
    groupCompanyGuid,
    setGroupCompanyGuid,
    company,
    setCompany,
    account,
    setAccount,
  };
}
export const [useAccountStore] = createGlobalStore(useAccount);
